export enum CourseOrderCustomerType {
  Participant = "participant",
  InvoiceRecipient = "invoiceRecipient",
}
